import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/homepage.scss';
import { Container } from "react-bootstrap";


function SignUpBlockHomepage(props) {


    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [buttonLink] = useState(props.bannerLink);
    const [buttonName] = useState(props.buttonName);
    const [target] = useState(props.target);



    return (

        <Container className="getReadySectionLayoutHomepage mt-5 mb-5">
            <div className="getReadySectionTitles">
                <div className="getReadySectionHeader">
                    <div className="getReadySectionHeaderContent"> {title}</div>
                </div>
                <div className="getReadySectionCopy">
                    <div className="getReadySectionCopyContent mb-4">{subTitle}</div>
                </div>
                <div className="buttonDiv">
                    <a href={buttonLink} target={target ? target :"_blank"} className="wid80 d-flex justify-content-center"  >
                        <div className="buttonWithoutBorder buttonSignUp pad5-4">
                            <div className="buttonLetters">{buttonName}</div>
                        </div>
                    </a>
                </div>
            </div>
        </Container>

    )


}

export default withRouter(SignUpBlockHomepage);



